import styled from 'styled-components/native';

export default styled;
